import { NexusChat } from "@/components/NexusChat";
import { Logo } from "@/components/brand/Logo";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Chat() {
  return (
    <div className="h-screen flex flex-col">
      <div className="tdw-navy-bg text-white px-4 h-14 flex items-center justify-between shrink-0">
        <Logo variant="wordmark-light" />
        <Link to="/" className="text-sm text-slate-300 hover:text-tech flex items-center gap-1.5" data-testid="chat-back"><ArrowLeft className="h-4 w-4" /> Back to site</Link>
      </div>
      <div className="flex-1 max-w-3xl w-full mx-auto border-x border-slate-200 min-h-0">
        <NexusChat fullScreen source="chat-page" />
      </div>
    </div>
  );
}
